<template>
  <div class="pa-5">
    <v-card shaped class="elevation-10">
      <v-card-title>การกำหนดตำแหน่งทางวิชาการ</v-card-title>
      <v-subheader>ค้นหาบุคลากร</v-subheader>
      <v-card-text class="pt-0">
        <v-text-field 
          v-model="name"
          @input="searchChange"
          solo
          dense 
          label="ค้นหาชื่อบุลากร" 
          prepend-inner-icon="mdi-account"
        ></v-text-field>
      </v-card-text>

      <div v-if="staffs.length > 0">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  
                </th>
                <th class="text-left">
                  ชื่อ สกุล
                </th>
                <th class="text-left">
                  #
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in staffs"
                :key="item.id"
              >
                <td style="width: 15%;">
                  <div class="py-2">
                    <v-img class="rounded elevation-5" :src="`https://mis.srru.ac.th${item.img}`" max-height="150" max-width="100"></v-img>
                  </div>
                </td>
                <td>{{ item.display_name }}</td>
                <td style="width: 15%;">
                  <v-btn color="success" :to="`/academic/${item.id}/report`">รายงาน</v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  data: () => ({
    name: '',
    staffs: []
  }),
  methods: {
    getStaffs(name) {
      this.$store.dispatch('academic/getStaffs', name)
        .then(data => this.staffs = data);
    },
    toDetail() {
      
      this.$router.push({ name: 'Academic' });
    },
    searchChange: _.debounce(function(e) {
			this.getStaffs(e);
		}, 500)
  }
}
</script>